jQuery(document).ready(function () {
  if (document.cookie.indexOf('cookie-banner=allow') === -1) {
    jQuery('.cookie-banner').show();
  } else {
    jQuery('.cookie-banner').hide();
  }

  jQuery('.cookie-banner .accept').on('click', function () {
    document.cookie = "cookie-banner=allow; path=/; max-age=" + (365 * 24 * 60 * 60);
    jQuery(this).closest('.cookie-banner').hide();
  });
});
